module.exports = __webpack_public_path__ + "img/chanpin.e65e929f.png";